import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import LoadingSpinner from './ui/LoadingSpinner';

const UserProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useUser();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-midnight-50">
                <LoadingSpinner size="lg" />
            </div>
        );
    }

    if (!isAuthenticated) {
        // Redirect to user login with return URL
        const returnUrl = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/user/login?redirect=${returnUrl}`} replace />;
    }

    return children;
};

export default UserProtectedRoute;
